/*
MP Tentativo checkbox richiedi installazione prima del campo note.
Problema: non mantiene la selezione "flaggato" al cambiare di pagina. Viene ripristinata solo ad eventi js del carrello (es: hover prodotto)
*/
/*
// Configurazione testo traducibile dal pannello Shopify
const checkboxElement = document.getElementById('installation-checkbox');
const CHECKBOX_TEXT = checkboxElement?.dataset.checkboxText || "Chiamatemi per preventivo installazione";
const CHECKBOX_LABEL = checkboxElement?.dataset.checkboxLabel || "Ho bisogno dell'installazione di almeno uno dei prodotti, chiamatemi alla ricezione dell'ordine";

const STORAGE_KEY = 'cart_installation_requested';

// Funzione per gestire il checkbox
function setupInstallationCheckbox() {
  const checkbox = document.getElementById('installation-checkbox');
  const noteField = document.getElementById('CartDrawer-Note');

  if (!checkbox || !noteField) {
    return false;
  }

  // Evita di inizializzare più volte lo stesso checkbox
  if (checkbox.dataset.initialized === 'true') {
    return true;
  }

  // Ripristina lo stato salvato IMMEDIATAMENTE
  const savedState = localStorage.getItem(STORAGE_KEY) === 'true';
  
  // Marca come inizializzato PRIMA di clonare
  checkbox.dataset.initialized = 'true';
  checkbox.checked = savedState;
  
  // Se era selezionato, aggiungi il testo
  if (savedState && !noteField.value.includes(CHECKBOX_TEXT)) {
    noteField.value = noteField.value 
      ? `${noteField.value}\n\n${CHECKBOX_TEXT}` 
      : CHECKBOX_TEXT;
  }

  // Aggiungi listener senza clonare (per evitare di perdere lo stato)
  checkbox.addEventListener('change', function handleCheckboxChange() {
    // Salva lo stato
    localStorage.setItem(STORAGE_KEY, this.checked);
    
    if (this.checked) {
      // Aggiungi il testo se non è già presente
      if (!noteField.value.includes(CHECKBOX_TEXT)) {
        noteField.value = noteField.value 
          ? `${noteField.value}\n\n${CHECKBOX_TEXT}` 
          : CHECKBOX_TEXT;
      }
    } else {
      // Rimuovi il testo
      noteField.value = noteField.value
        .replace(CHECKBOX_TEXT, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    }
  }, { once: false });

  return true;
}

// Funzione che tenta di inizializzare il checkbox con retry
function initWithRetry(maxAttempts = 20, delay = 50) {
  let attempts = 0;
  
  const tryInit = function() {
    attempts++;
    const success = setupInstallationCheckbox();
    
    if (!success && attempts < maxAttempts) {
      setTimeout(tryInit, delay);
    }
  };
  
  tryInit();
}

// Ascolta l'apertura del drawer
document.addEventListener('cart-drawer-open', function() {
  initWithRetry();
});

// Re-applica lo stato quando il carrello viene aggiornato (cambio quantità)
document.addEventListener('cart-update', function(event) {
  const { cartData } = event.detail;
  
  // Pulizia localStorage solo quando il carrello viene completamente svuotato
  if (cartData && cartData.item_count === 0) {
    localStorage.removeItem(STORAGE_KEY);
  }
  
  initWithRetry();
});

// Re-applica lo stato quando un prodotto viene rimosso
document.addEventListener('cart-remove', function(event) {
  const { cartData } = event.detail;
  
  // Pulizia localStorage solo quando il carrello viene completamente svuotato
  if (cartData && cartData.item_count === 0) {
    localStorage.removeItem(STORAGE_KEY);
  }
  
  initWithRetry();
});

// Inizializza al caricamento pagina
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initWithRetry();
  });
} else {
  initWithRetry();
}
  */


/**
 * Script per visualizzare prezzi IVA esclusa + IVA inclusa
 * Con supporto multi-mercato automatico (Shopify Markets)
 * Version: 4.0 - Multi-Market Auto-detect
 */

(function() {
  'use strict';
  
  // ========================================================================
  // CONFIGURAZIONE IVA PER PAESE
  // ========================================================================
  
  // Mappa aliquote IVA per codice paese ISO
  // Il cliente può aggiungere nuovi paesi qui
  const VAT_RATES = {
    'IT': 0.22,  // Italia - 22%
    'DE': 0.19,  // Germania - 19%
    'FR': 0.20,  // Francia - 20%
    'ES': 0.21,  // Spagna - 21%
    'AL': 0.20,  // Albania - 20%
    
    // Altri paesi comuni (già pronti per essere usati)
    'AT': 0.20,  // Austria - 20%
    'BE': 0.21,  // Belgio - 21%
    'BG': 0.20,  // Bulgaria - 20%
    'HR': 0.25,  // Croazia - 25%
    'CY': 0.19,  // Cipro - 19%
    'CZ': 0.21,  // Repubblica Ceca - 21%
    'DK': 0.25,  // Danimarca - 25%
    'EE': 0.22,  // Estonia - 22%
    'FI': 0.24,  // Finlandia - 24%
    'GR': 0.24,  // Grecia - 24%
    'HU': 0.27,  // Ungheria - 27%
    'IE': 0.23,  // Irlanda - 23%
    'LV': 0.21,  // Lettonia - 21%
    'LT': 0.21,  // Lituania - 21%
    'LU': 0.17,  // Lussemburgo - 17%
    'MT': 0.18,  // Malta - 18%
    'NL': 0.21,  // Paesi Bassi - 21%
    'PL': 0.23,  // Polonia - 23%
    'PT': 0.23,  // Portogallo - 23%
    'RO': 0.19,  // Romania - 19%
    'SK': 0.20,  // Slovacchia - 20%
    'SI': 0.22,  // Slovenia - 22%
    'SE': 0.25,  // Svezia - 25%
    'GB': 0.20,  // Regno Unito - 20%
    'CH': 0.077, // Svizzera - 7.7%
    'NO': 0.25,  // Norvegia - 25%
    'US': 0.00,  // USA - varia per stato (default 0)
  };
  
  // IVA di default se paese non trovato
  const DEFAULT_VAT_RATE = 0.22;
  
  // ========================================================================
  // CONFIGURAZIONE GENERALE
  // ========================================================================
  
  const CONFIG = {
    // Selettori CSS
    selectors: {
      salePrices: '.price-item--sale',
      regularStriked: 's.price-item--regular, s .price-item--regular',
      regularNonStriked: '.price__regular > .price-item--regular',
    },
    
    // Formato numeri (mantieni quello italiano come default)
    numberFormat: {
      thousands: '.',
      decimal: ',',
      decimals: 2
    },
    
    // Testi label - mappa per lingua
    labels: {
      'it': { exclVAT: 'IVA escl.', inclVAT: 'IVA incl.' },
      'de': { exclVAT: 'exkl. MwSt.', inclVAT: 'inkl. MwSt.' },
      'fr': { exclVAT: 'HT', inclVAT: 'TTC' },
      'es': { exclVAT: 'sin IVA', inclVAT: 'con IVA' },
      'sq': { exclVAT: 'pa TVSH', inclVAT: 'me TVSH' }, // Albanese
      'en': { exclVAT: 'Excl. VAT', inclVAT: 'Incl. VAT' },
    },
    
    // Osservatore per contenuti dinamici
    observer: {
      enabled: true,
      watchContainers: ['#CartDrawer', '.product-grid', '.search-results']
    },
    
    // Debug mode
    debug: false
  };
  
  // ========================================================================
  // RILEVAMENTO MERCATO E IVA
  // ========================================================================
  
  /**
   * Rileva il codice paese dal mercato attivo
   * Approccio ibrido: priorità a dati Shopify affidabili, fallback a URL
   */
  function detectCountryCode() {
    // PRIORITY 1: window.ShopifyMarketData (se snippet Liquid presente) - 100% accurato
    if (typeof window.ShopifyMarketData !== 'undefined' && window.ShopifyMarketData.country) {
      const countryCode = window.ShopifyMarketData.country.toUpperCase();
      if (CONFIG.debug) {
        console.log('[VAT Script] ✅ Paese da Liquid data:', countryCode);
        console.log('[VAT Script] Dati mercato completi:', window.ShopifyMarketData);
      }
      return countryCode;
    }
    
    // PRIORITY 2: window.Shopify.country - molto affidabile (riflette mercato attivo)
    if (typeof Shopify !== 'undefined' && Shopify.country) {
      const countryCode = Shopify.country.toUpperCase();
      if (CONFIG.debug) {
        console.log('[VAT Script] ✅ Paese da Shopify.country:', countryCode);
      }
      return countryCode;
    }
    
    // PRIORITY 3: URL pattern /de, /fr, /es - approssimativo (lingua ≠ mercato)
    // Questo è un FALLBACK meno preciso: /de potrebbe essere Germania O Austria O Svizzera tedesca
    const urlMatchSingle = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
    if (urlMatchSingle) {
      // Mappa lingua → paese (approssimativo!)
      const langToCountry = {
        'de': 'DE', // Tedesco → Germania (ma potrebbe essere AT, CH)
        'fr': 'FR', // Francese → Francia (ma potrebbe essere BE, CH)
        'es': 'ES', // Spagnolo → Spagna
        'it': 'IT', // Italiano → Italia
        'sq': 'AL', // Albanese → Albania
        'en': 'GB', // Inglese → UK (approssimativo)
        'pt': 'PT', // Portoghese → Portogallo
        'nl': 'NL', // Olandese → Paesi Bassi (ma potrebbe essere BE)
        'pl': 'PL', // Polacco → Polonia
        'el': 'GR', // Greco → Grecia
        'sv': 'SE', // Svedese → Svezia
        'da': 'DK', // Danese → Danimarca
        'fi': 'FI', // Finlandese → Finlandia
        'no': 'NO', // Norvegese → Norvegia
      };
      
      const langCode = urlMatchSingle[1].toLowerCase();
      const countryCode = langToCountry[langCode] || 'IT';
      
      if (CONFIG.debug) {
        console.warn('[VAT Script] ⚠️ Fallback URL (meno preciso: lingua ≠ mercato)');
        console.log('[VAT Script] Paese da URL:', langCode, '→', countryCode);
      }
      return countryCode;
    }
    
    // PRIORITY 4: Prova pattern doppio /de-de, /fr-fr (se configurato così)
    const urlMatchDouble = window.location.pathname.match(/^\/[a-z]{2}-([a-z]{2})\//i);
    if (urlMatchDouble) {
      const countryCode = urlMatchDouble[1].toUpperCase();
      if (CONFIG.debug) {
        console.log('[VAT Script] Paese da URL (pattern doppio):', countryCode);
      }
      return countryCode;
    }
    
    // 2. Prova a rilevare da oggetto Shopify (se disponibile)
    if (typeof Shopify !== 'undefined' && Shopify.country) {
      const countryCode = Shopify.country.toUpperCase();
      if (CONFIG.debug) {
        console.log('[VAT Script] Paese rilevato da Shopify.country:', countryCode);
      }
      return countryCode;
    }
    
    // 3. Prova a rilevare da attributo HTML lang
    const htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang) {
      // Pattern: it-IT, de-DE, fr-FR
      const langMatch = htmlLang.match(/^[a-z]{2}-([A-Z]{2})$/);
      if (langMatch) {
        const countryCode = langMatch[1];
        if (CONFIG.debug) {
          console.log('[VAT Script] Paese rilevato da HTML lang:', countryCode);
        }
        return countryCode;
      }
    }
    
    // 4. Fallback a Italia
    if (CONFIG.debug) {
      console.warn('[VAT Script] Paese non rilevato, uso default: IT');
    }
    return 'IT';
  }
  
  /**
   * Rileva il codice lingua per le label
   */
  function detectLanguageCode() {
    // 1. Da URL pattern /de, /fr, /es (o /de-de, /fr-fr se presente)
    const urlMatchSingle = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
    if (urlMatchSingle) {
      return urlMatchSingle[1].toLowerCase();
    }
    
    const urlMatchDouble = window.location.pathname.match(/^\/([a-z]{2})-[a-z]{2}\//i);
    if (urlMatchDouble) {
      return urlMatchDouble[1].toLowerCase();
    }
    
    // 2. Da HTML lang
    const htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang) {
      return htmlLang.split('-')[0].toLowerCase();
    }
    
    // 3. Fallback a italiano
    return 'it';
  }
  
  /**
   * Ottieni l'aliquota IVA per il paese corrente
   */
  function getVATRate() {
    const countryCode = detectCountryCode();
    const vatRate = VAT_RATES[countryCode] || DEFAULT_VAT_RATE;
    
    if (CONFIG.debug) {
      console.log(`[VAT Script] IVA per ${countryCode}: ${(vatRate * 100).toFixed(1)}%`);
    }
    
    return vatRate;
  }
  
  /**
   * Ottieni le label nella lingua corretta
   */
  function getLabels() {
    const langCode = detectLanguageCode();
    const labels = CONFIG.labels[langCode] || CONFIG.labels['it'];
    
    if (CONFIG.debug) {
      console.log('[VAT Script] Lingua rilevata:', langCode, '→', labels);
    }
    
    return labels;
  }
  
  // ========================================================================
  // LOGICA TRASFORMAZIONE PREZZI
  // ========================================================================
  
  const VAT_RATE = getVATRate();
  const LABELS = getLabels();
  
  /**
   * Formatta un numero come prezzo
   */
  function formatPrice(price) {
    const formatted = price.toFixed(CONFIG.numberFormat.decimals);
    const [integer, decimal] = formatted.split('.');
    
    let integerFormatted = integer;
    if (CONFIG.numberFormat.thousands) {
      integerFormatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, CONFIG.numberFormat.thousands);
    }
    
    return integerFormatted + CONFIG.numberFormat.decimal + decimal;
  }
  
  /**
   * Calcola il prezzo IVA esclusa
   */
  function calculatePriceExclVAT(priceInclVAT) {
    return priceInclVAT / (1 + VAT_RATE);
  }
  
  /**
   * Estrae il valore numerico da una stringa di prezzo
   */
  function parsePriceFromText(priceText) {
    if (!priceText) return null;
    
    let cleanText = priceText.replace(/[€$£¥\s]/g, '');
    
    // Formato europeo: punto = migliaia, virgola = decimali
    cleanText = cleanText.replace(/\./g, '');
    cleanText = cleanText.replace(',', '.');
    
    const price = parseFloat(cleanText);
    
    if (isNaN(price) || price <= 0) {
      if (CONFIG.debug) {
        console.warn('[VAT Script] Parsing fallito per:', priceText);
      }
      return null;
    }
    
    return price;
  }
  
  /**
   * Trasforma un singolo elemento prezzo
   */
  function transformPriceElement(priceElement) {
    if (priceElement.dataset.vatProcessed === 'true') {
      return;
    }
    
    const originalText = priceElement.textContent.trim();
    const priceInclVAT = parsePriceFromText(originalText);
    
    if (!priceInclVAT) {
      if (CONFIG.debug) {
        console.warn('[VAT Script] Impossibile parsare prezzo:', originalText);
      }
      return;
    }
    
    const priceExclVAT = calculatePriceExclVAT(priceInclVAT);
    const isStriked = priceElement.closest('s') !== null;
    
    // Estrai simbolo valuta
    const currencyMatch = originalText.match(/[€$£¥]/);
    const currency = currencyMatch ? currencyMatch[0] : '€';
    
    // Crea il markup con le label corrette per la lingua
    const newMarkup = isStriked ? `
      <span class="price-vat-wrapper">
        <span class="price-excl-vat"><s>${currency}${formatPrice(priceExclVAT)}</s> <small>${LABELS.exclVAT}</small></span>
        <span class="price-incl-vat"><s>${currency}${formatPrice(priceInclVAT)}</s> <small>${LABELS.inclVAT}</small></span>
      </span>
    ` : `
      <span class="price-vat-wrapper">
        <span class="price-excl-vat">${currency}${formatPrice(priceExclVAT)} <small>${LABELS.exclVAT}</small></span>
        <span class="price-incl-vat">${currency}${formatPrice(priceInclVAT)} <small>${LABELS.inclVAT}</small></span>
      </span>
    `;
    
    priceElement.innerHTML = newMarkup;
    priceElement.dataset.vatProcessed = 'true';
    
    if (CONFIG.debug) {
      console.log('[VAT Script] Processato:', originalText, '→', 
                  priceExclVAT.toFixed(2), '(excl) /', priceInclVAT.toFixed(2), '(incl)');
    }
  }
  
  /**
   * Processa tutti i prezzi nella pagina
   * FIX: usa selettori specifici per evitare duplicati
   */
  function processAllPrices() {
    // SELETTORI SPECIFICI per evitare di processare lo stesso prezzo due volte
    
    // 1. Prezzi di vendita (sempre visibili)
    const salePrices = document.querySelectorAll(
      '.price-item--sale:not([data-vat-processed="true"])'
    );
    
    // 2. Prezzi regolari BARRATI (tag <s> che sono price-item--regular)
    // Sia s .price-item--regular che s.price-item--regular
    const regularPricesStriked = document.querySelectorAll(
      's.price-item--regular:not([data-vat-processed="true"]), s .price-item--regular:not([data-vat-processed="true"])'
    );
    
    // 3. Prezzi regolari NON BARRATI (solo se non c'è sale price)
    // Questi sono i prezzi normali quando il prodotto non è in sconto
    const regularPricesNonStriked = document.querySelectorAll(
      '.price__regular > .price-item--regular:not([data-vat-processed="true"])'
    );
    
    let processedCount = 0;
    
    // Processa prezzi in sconto
    salePrices.forEach(element => {
      transformPriceElement(element);
      processedCount++;
    });
    
    // Processa prezzi regolari barrati
    regularPricesStriked.forEach(element => {
      transformPriceElement(element);
      processedCount++;
    });
    
    // Processa prezzi regolari non barrati
    regularPricesNonStriked.forEach(element => {
      transformPriceElement(element);
      processedCount++;
    });
    
    if (processedCount > 0 && CONFIG.debug) {
      console.log(`[VAT Script] Processati ${processedCount} prezzi`);
    }
  }
  
  /**
   * Setup MutationObserver per contenuti dinamici
   */
  function setupMutationObserver() {
    if (!CONFIG.observer.enabled) return;
    
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const isRelevant = CONFIG.observer.watchContainers.some(selector => 
              node.matches && (node.matches(selector) || node.querySelector(selector))
            ) || node.classList.contains('price') || node.querySelector('.price-item');
            
            if (isRelevant) {
              shouldProcess = true;
            }
          }
        });
      });
      
      if (shouldProcess) {
        processAllPrices();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    if (CONFIG.debug) {
      console.log('[VAT Script] MutationObserver attivo');
    }
  }
  
  /**
   * Inizializzazione
   */
  function init() {
    if (CONFIG.debug) {
      const countryCode = detectCountryCode();
      const langCode = detectLanguageCode();
      console.log('[VAT Script] ========================================');
      console.log('[VAT Script] Inizializzazione Multi-Market');
      console.log('[VAT Script] Paese:', countryCode);
      console.log('[VAT Script] Lingua:', langCode);
      console.log('[VAT Script] IVA:', (VAT_RATE * 100).toFixed(1) + '%');
      console.log('[VAT Script] Labels:', LABELS);
      console.log('[VAT Script] ========================================');
    }
    
    processAllPrices();
    setupMutationObserver();
    
    // Eventi Shopify
    document.addEventListener('shopify:section:load', processAllPrices);
    document.addEventListener('shopify:section:reorder', processAllPrices);
    
    if (CONFIG.debug) {
      console.log('[VAT Script] Inizializzazione completata');
    }
  }
  
  // Esegui quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Esponi per debug
  window.VATScriptInfo = {
    country: detectCountryCode(),
    language: detectLanguageCode(),
    vatRate: VAT_RATE,
    labels: LABELS,
    availableCountries: Object.keys(VAT_RATES)
  };
  
})();